import { IReportForm } from 'app/components/reports-form/reports-form.component';
import { ReportTypes } from './enum.service';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ControlType } from 'app/components/form-component/control-type-enum';


import { IForm, IOptions } from 'app/components/form-component/form-component.component';

@Injectable()
export class FormService {
    protected reportTypes = ReportTypes;
    constructor() { }

    toFormGroup(form: IForm[]) {
        let fb: FormGroup = new FormGroup({});
        const group: any = {};

        form.forEach(form => {
            if (form.controlType !== ControlType.headline && form.controlType !== ControlType.subHeadline && form.controlType !== ControlType.break) {
                group[form.key] = form.required ? new FormControl({ value: form.value, disabled: form.readonly }, !form.validators ? Validators.required : [Validators.required, form.validators]) : new FormControl({ value: form.value, disabled: form.readonly });
            }
        });
        fb = new FormGroup(group).getRawValue();
        return new FormGroup(group)
    }

    reportFormGroup(form: IReportForm[], reportType: ReportTypes) {
        let fb: FormGroup = new FormGroup({});
        const group: any = {};
        form.forEach(form => {
            let reportIncluded: boolean = this.isReportIncluded(reportType, form.reportType);
            if (reportIncluded) {
                group[form.key] = form.required ? new FormControl({ value: form.value, disabled: form.disabled }, Validators.required) : new FormControl({ value: form.value, disabled: form.disabled });
            }
        });
        fb = new FormGroup(group).getRawValue();
        return new FormGroup(group)
    }

    /*
    *   check if report type exists in forms array types
    */
    public isReportIncluded(reportType: ReportTypes, reportTypes: ReportTypes[]): boolean {
        if (reportTypes.includes(reportType)) {
            return true;
        }
        return false;
    }
}
